import { AuditingStep } from './types';

export const AUDITING_STEP: AuditingStep = AuditingStep.Start;
